import React from 'react';
import { Button } from 'react-bootstrap';
import { FaFilePdf } from 'react-icons/fa';
import { jsPDF } from "jspdf";

const GenerarCredencial = ({ estudiante, imagenPerfil }) => {
  const generarCredencial = async () => {
    const doc = new jsPDF({ unit: "mm", format: [85.6, 53.98] });
    const { EstudianteID, Nombre, ApellidoPaterno, ApellidoMaterno, Grado, Grupo, Turno } = estudiante;
    const imagen = imagenPerfil !== "/images/default-profile.png" ? imagenPerfil : "/images/default-profile.png";
    const logo = "/images/logo.png";
    const firma = "/images/firma.png";
  
    const loadImage = (src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('Failed to load image'));
      });
    };
  
    try {
      const [profileImage, logoImage, firmaImage] = await Promise.all([
        loadImage(imagen), loadImage(logo), loadImage(firma)
      ]);
  
      doc.setTextColor(2, 54, 131);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Secundaria 39 Mixta\n\"J. Jesús Sezate Garay\"\nCLAVE: 14EES0019Q", 26.99, 5, null, null, "center");
  
      doc.setTextColor(0, 0, 0);
      doc.addImage(logo, "PNG", 7, 15, 15, 20);
      doc.addImage(profileImage, "PNG", 26.99, 16, 20, 20);
  
      doc.setFontSize(6);
      doc.text(`Alumno:`, 22, 40);
      doc.text(`${Nombre} ${ApellidoPaterno} ${ApellidoMaterno}`, 5, 43);
      doc.text(`Emergencias:`, 5, 46);
      doc.text(`Grado: ${Grado}, Grupo: ${Grupo}`, 5, 49);
      doc.text(`Turno: ${Turno}`, 5, 52);
      doc.text(`2023 - 2024`, 5, 55);
  
      doc.setFontSize(8);
      doc.text(`Código:`, 22, 60);
      doc.text(`${EstudianteID}`, 19, 65);
  
      doc.addPage();
      doc.setFontSize(8);
      doc.setTextColor(2, 54, 131);
      doc.addImage(logoImage, "PNG", 7, 15, 15, 20);
      doc.addImage(firmaImage, "PNG", 26.99, 16, 20, 20);
      doc.setFontSize(8);
      doc.text("Ángeles Miroslava Esparza Silva", 26, 43, null, null, "center");
      doc.text("Directora", 26, 47, null, null, "center");
      doc.text("Bolaños S/N", 26, 51, null, null, "center");
      doc.text("Col. Lomas del Laurel C.P. 44000", 26, 55, null, null, "center");
      doc.text("Tonalá, Jalisco", 26, 59, null, null, "center");
      doc.text("Tel. 33 1053 6668", 26, 63, null, null, "center");
  
      doc.save(`${Nombre}_${ApellidoPaterno}_Credencial.pdf`);
    } catch (error) {
      console.error("Error al cargar las imágenes", error);
    }
  };

  return (
    <Button variant="info" className="me-2" onClick={generarCredencial}>
      <FaFilePdf /> Generar Credencial
    </Button>
  );
};

export default GenerarCredencial;
